module.exports = __webpack_public_path__ + "static/media/phone.98cd2727.svg";